var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileWrapper',[_c('UiHeading',{staticClass:"profile-data--heading --no-border",attrs:{"level":1,"content":_vm.$t('front.loyalty.views.benefits.heading')}}),_c('BenefitPrograms')],1)}
var staticRenderFns = []

export { render, staticRenderFns }